<h3
  mat-dialog-title
  class="pt-3">
  {{ data.title }}
</h3>
@if (data.message.length > 0) {
  <mat-dialog-content>
    <p [innerHTML]="data.message + '<br>' + data.subMessage"></p>
  </mat-dialog-content>
}
<mat-dialog-actions class="justify-content-center">
  <div
    class="d-flex flex-column gap-4 gap-sm-2 align-items-center justify-content-evenly"
    [class.flex-sm-row]="!revertButtons"
    [class.flex-sm-row-reverse]="revertButtons">
    <wfs-form-button
      (buttonClicked)="triggerEvent(true)"
      [label]="data.confirmText"
      [buttonStyle]="data.buttonStyles['confirm']" />
    <wfs-form-button
      (buttonClicked)="triggerEvent(false)"
      [label]="data.denyText"
      [buttonStyle]="data.buttonStyles['deny']" />
  </div>
</mat-dialog-actions>
